







































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import ClassificationDialogComponent from '@/components/ClassificationDialogComponent.vue'
import { Classification } from '@/domain/Classification'
import { Department } from '@/domain/Department'
import { ReportType } from '@/domain/ReportType'
import ClassificationsService from '@/service/ClassificationsService'
import DepartmentsService from '@/service/DepartmentsService'
import ReportTypesService from '@/service/ReportTypesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    ClassificationDialogComponent,
  },
})
export default class MasterClassificationList extends Mixins(GlobalMixin) {
  classificationsService = ClassificationsService.instance
  departmentsService = DepartmentsService.instance
  reportTypesService = ReportTypesService.instance


  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "検査分類コード", value: "code", width: "140px" },
          { text: "検査分類名", value: "name" },
          { text: "部門名", value: "departmentCode", width: "200px" },
          { text: "操作", value: "actions", sortable: false, width: "60px" },
  ]
  list: Classification[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  departments: Department[] = []
  reportTypes: ReportType[] = []

  dto: Classification =  new Classification()
  classificationDialog = false

  /**
   * 初期実行
   */
  mounted() {
    /* 部門 */
    this.departmentsService.findAll()
      .then(x => this.departments = x)
    /* 報告書タイプ */
    this.reportTypesService.findAll()
      .then(x => this.reportTypes = x)
    /* 初期検索 */  
    this.search()
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Classification) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.code) {
      this.onEdit(event.code)
    }
    this.rowItemKey = event.code
    this.rowItemClickTime = now
  }

  /**
   * 部門名を取得する
   */
  getDepartmentName(code: string) {
    const department = this.departments.find(x => x.code === code)
    return department === undefined ? "" : department.name
  }

  /**
   * 報告書名を取得する
   */
  getReportTypeName(code: string) {
    const reportType = this.reportTypes.find(x => x.code === code)
    return reportType === undefined ? "" : reportType.name
  }

  /**
   * 新規作成
   */
  onNew() {
    this.classificationsService.createNew()
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.classificationDialog = true
      })
  }

  /**
   * 編集
   */
  onEdit(code: string) {
    this.classificationsService.edit(code)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.dto = x
        this.classificationDialog = true
      })
  }

  /**
   * ダイアログの確定処理
   */
  onClassificationSubmit(dto: Classification) {
    this.showLoading()
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 新規登録 */
      this.classificationsService.create(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    } else {
      /* 更新 */
      this.classificationsService.update(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.classificationsService.findAll()
      .then(x => {
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
